import { IUserState } from './interface';

export const getUsersCount = (state: any): string => {
  return (state?.userReducer as IUserState)?.users_count;
};
